import { render, staticRenderFns } from "./ComandoVelocidadAsignacion.vue?vue&type=template&id=21e45a0a&scoped=true&"
import script from "./ComandoVelocidadAsignacion.vue?vue&type=script&lang=ts&"
export * from "./ComandoVelocidadAsignacion.vue?vue&type=script&lang=ts&"
import style0 from "./ComandoVelocidadAsignacion.vue?vue&type=style&index=0&id=21e45a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e45a0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('21e45a0a', component.options)
    } else {
      api.reload('21e45a0a', component.options)
    }
    module.hot.accept("./ComandoVelocidadAsignacion.vue?vue&type=template&id=21e45a0a&scoped=true&", function () {
      api.rerender('21e45a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ComandoVelocidad/ComandoVelocidadAsignacion.vue"
export default component.exports